export function detectLanguage(): string {
    return new URLSearchParams(document.location.search).get('lang')
        || navigator.language.split('-')[0]!;
}
